"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseConnextFacet__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "BaseConnextFacet__getAdoptedAsset_assetNotFound",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__getApprovedCanonicalId_notAllowlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__nonReentrant_reentrantCall",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__nonXCallReentrant_reentrantCall",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrAdmin_notOwnerOrAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrRouter_notOwnerOrRouter",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwnerOrWatcher_notOwnerOrWatcher",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyOwner_notOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__onlyProposed_notProposedOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "BaseConnextFacet__whenNotPaused_paused",
        type: "error",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b50603f80601d6000396000f3fe6080604052600080fdfea26469706673582212208836cc698e557e055bab3cef65ef0293da7955e109e6ee6ede1f4f3c932c3cc764736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class BaseConnextFacet__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BaseConnextFacet__factory = BaseConnextFacet__factory;
BaseConnextFacet__factory.bytecode = _bytecode;
BaseConnextFacet__factory.abi = _abi;
//# sourceMappingURL=BaseConnextFacet__factory.js.map